// extracted by mini-css-extract-plugin
export default {"publiclayoutContainer":"layoutstyle_publiclayoutContainer__lBopY","contentBox":"layoutstyle_contentBox__L479s"};